import React from 'react';

import PoiCardSkeleton from '../cards/poi/PoiCardSkeleton';

function ResultsSkeletonLoader() {
    const numberOfCards = 12;
    const fakeCards = Array(numberOfCards).fill(0);
    return (
        <div className="container grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3  xl:grid-cols-4 xl:gap-10 3xl:grid-cols-5 3xl:gap-14">
            {fakeCards.map((k, i) => (
                <div className="justify-self-center w-full h-72" key={i}>
                    <PoiCardSkeleton />
                </div>
            ))}
        </div>
    );
}

ResultsSkeletonLoader.propTypes = {};

export default ResultsSkeletonLoader;
